<template>
  <div class="wrapper">
    <el-dialog
      :title="$t('shippingAddress')"
      :show-close="false"
      :visible.sync="dialogAdressVisible"
      :close-on-click-modal="false"
      class="adress"
    >
      <div class="adress-form">
        <div class="form-section form-name">
          <input
            type="text"
            :placeholder="$t('pleaseEnterTheNameOfConsignee')"
            class="input-text input-control"
            v-model="userName"
          >
          <label for class="input-label">{{$t('name')}}</label>
        </div>
        <div class="form-section">
          <input
            type="text"
            :placeholder="$t('pEenterPhoneNumber')"
            minlength="7"
            maxlength="11"
            class="input-text input-control"
            v-model="telPhone"
          >
          <label for class="input-label">{{$t('mobile')}}</label>
        </div>
        <div class="form-section form-adress form-location">
          <el-cascader size="medium" :options="options" separator=" " 
          :placeholder="$t('pleaseSelect')" v-model="selectedOptions"></el-cascader>
        </div>

        <!-- 详细地址 -->
        <div class="form-section form-adress">
          <textarea
            class="input-textarea input-control"
            cols="25"
            rows="3"
            :placeholder="$t('pleaseEntershippingAddress')"
            v-model="detailAddress"
          ></textarea>
          <label for class="input-label">{{$t('detailedAddress')}}</label>
        </div>

        <!-- 智能解析 -->
        <div class="form-section form-adress">
          <textarea
            class="input-textarea input-control"
            cols="25"
            rows="3"
            :placeholder="$t('analysisTips')"
            v-model="smartAddress"
          ></textarea>
          <label for class="input-label">{{$t('smartParsing')}}</label>
          <div class="smart"> 
            <span @click="smart">
               <!-- 解析 -->
               {{$t('analysis')}}
            </span>
          </div>
        </div>
      </div>
      <div class="form-foot">
        <div class="foot-btn save" @click="saveFormInfo">{{$t('save')}}</div>
        <div class="foot-btn cancel" @click="hideDialog">{{$t('cancel')}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { CodeToText } from "element-china-area-data";
import AddressParse from 'address-parse';
import * as locationData from "@/utils/location.js";
import { inputCheckPhone } from "@/utils/index";
import { mapActions } from "vuex";
export default {
  name: "SelectAddress",
  components: {},
  props: {
    dialogAdressVisible: {
      type: Boolean,
      default: false
    },
    data: Object
  },
  data() {
    return {
      //地址管理
      // addressArray:[],
      userName: null,
      telPhone: null,
      selectedOptions: [],
      detailAddress: null,
      postCode: null,
      addressTag: null,
      options: {}, //省市联动数据
      type: 0, // 0为新增 ,1为修改
      provinceKey: 110000, //省份id
      cityKey: 110100, //市id
      areaKey: 110101, //区域idmultiIndex: [110000, 110100, 110101],
      test: [],
      smartAddress: ''
    };
  },
  watch: {
    data(newVal, oldval) {
      console.log(oldval)
      if (newVal.id) {
        this.init(newVal.area_id);
        this.type = 1;
        this.userName = newVal.name;
        this.telPhone = newVal.mobile;
        console.log('this.pickerIndexArr----', this.pickerIndexArr)
        this.selectedOptions = this.pickerIndexArr;
        this.detailAddress = newVal.address;
        // this.postCode = newVal.postCode;
        // this.addressTag = newVal.addressTag;
      } else {
        this.type = 0;
      }
    }
  },
  computed: {
    // selectedOptionsText() {
    //   let arr = this.selectedOptions;
    //   return (
    //     CodeToText[arr[0]] + " " + CodeToText[arr[1]] + " " + CodeToText[arr[2]]
    //   );
    // },
    pickerIndexArr() {
      return [this.provinceKey, this.cityKey, this.areaKey];
      // let arr = [this.provinceKey, this.cityKey, this.areaKey];
      // return arr.map(item=>{
      //   return item.toString()
      // })
    }
  },
  methods: {
    smart() {
      if(!this.smartAddress) {
        this.$message({
          message: this.$t('pleaseAnalysis'), // 请输入需要解析的地址
          type: 'error'
        })
        return
      }
      let res = AddressParse.parse(this.smartAddress)[0]
      this.userName = res.name
      this.telPhone = res.mobile
      this.detailAddress = res.details
      this.filter([res.province, res.city, res.area], this.options)
      this.selectedOptions = this.test

    },
    init(areaId) {
      this.getFullOptions(areaId, locationData);
    },
    getFullOptions(id, data) {
      for (var i = 0; i < data.length; i++) {
        if (id == data[i].value) {
          if (!data[i].children) {
            this.areaKey = data[i].value - 0;
            return true;
          } else if (data[i].hasOwnProperty("children")) {
            if (data[i].children[0] && !data[i].children[0].children) {
              this.cityKey = data[i].value;
              return true;
            } else {
              this.provinceKey = data[i].value;
              return true;
            }
          }
        } else {
          if (data[i].hasOwnProperty("children")) {
            if (data[i].children[0] !== undefined) {
              if (data[i].children[0].hasOwnProperty("children")) {
                this.provinceKey = data[i].value;
              } else {
                this.cityKey = data[i].value;
              }
            }
            if (typeof data[i].children != "undefined") {
              var res = this.getFullOptions(id, data[i].children);
              if (res) {
                return true;
              }
            }
          }
        }
      }
    },
    hideDialog() {
      this.$emit("hideDialog");
    },
    saveFormInfo() {
      if (!this.userName) {
        return this.$message.error(this.$t('pleaseEnterTheNameOfConsignee'));
      }
      if (!this.telPhone || !inputCheckPhone(this.telPhone)) {
        return this.$message.error(this.$t('phonenumberformatisincorrect'));
      }
      if (this.selectedOptions.length == 0) {
        return this.$message.error(this.$t('pleaseEntershippingAddress'));
      }
      if (!this.detailAddress) {
        return this.$message.error(this.$t('detailedAddress'));
      }
      // if (!this.postCode) {
      //   return this.$message.error("请输入邮政编码");
      // }

      let data = {
        name: this.userName,
        mobile: this.telPhone,
        // area_id: this.selectedOptions[2],
        area_id: this.selectedOptions[ this.selectedOptions.length - 1 ],

        address: this.detailAddress
        // selectedOptions: this.selectedOptions,
        // selectedOptionsText: this.selectedOptionsText,
        // postCode: this.postCode,
        // addressTag: this.addressTag
      };
      if (this.type == 0) {
        //新增
        this.handleSaveUserShip(data);
      } else {
        data["id"] = this.data.id;
        this.handleEditShip(data);
      }
    },
    //修改地址
    handleEditShip(data) {
      this.$api.editShip(data).then(res => {
        if (res.status) {
          this.$msg(this.$t('setSuccess'));
          this.getUserShipListAction(); //添加成功获取最新列表
          this.hideDialog();
          this.formReset();
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    //新增收货地址
    handleSaveUserShip(data) {
      this.$api.editShip(data).then(res => {
        if (res.status) {
          this.$msg(this.$t('success', {text: ''}));
          this.getUserShipListAction(); //添加成功获取最新列表
          this.hideDialog();
          this.formReset();
        } else {
          //this.$msg(res.msg, "error");
		  this.$message({
		    showClose: true,
		    message: res.msg,
		    type: "error",
			duration: 8000
		  });
        }
      });
    },
    ...mapActions(["getUserShipListAction"]),
    formReset() {
      this.userName = null;
      this.telPhone = null;
      this.selectedOptions = [];
      this.detailAddress = null;
      this.postCode = null;
      this.addressTag = null;
    },
    filter(arr1, arr2) {
      if(arr1.length == 0) {
        return
      }
      let shift = arr1.shift()
      for(let i = 0; i < arr2.length; i++) {
        if(arr2[i].label == shift) {
          this.test.push(arr2[i].value * 1)
          this.filter(arr1, arr2[i].children)
          break 
        }
      }
    },
    getTreeData(data){
      for(let i=0;i<data.length;i++){
        if('children' in data[i]) {
          if(!data[i].children || data[i].children.length<1){

            // console.log(data[i].children)
            // child若为空数组，则将child设为undefined
            data[i].children=undefined;
          }else {
            // child若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].children);
          }
        }
      }
      return data;
    }
  },
  created() {
    let addressList = this.$storage.get('areaList')
    this.options = this.getTreeData(addressList)
    console.log('this.getTreeData(addressList.data)', this.getTreeData(addressList))

    // if (addressList.hasOwnProperty('data')) {
    //   this.options = this.getTreeData(addressList.data) ;
    // } else {
    //   this.options = this.getTreeData(addressList);
    // }
  },
};
</script>
<style lang="scss">
@import "@/assets/css/variable.scss";
.smart {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  span {
    padding: 10px 20px;
    background: #e7442f;
    color: #fff;
    margin-top: 10px;
    cursor: pointer;
  }
}
.adress-form {
  width: 600px;
  margin: 0 auto;
  padding: 30px 10px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  align-content: flex-start;
  .form-section {
    position: relative;
    margin-bottom: 15px;
    &.form-adress {
      width: 100%;
    }
    .input-control {
      margin: 0;
      font-size: 14px;
      line-height: 1.5;
      outline: none;
      padding: 10px 16px;
      border: 1px solid #e0e0e0;
      transition: border-color 0.25s linear;
      &.input-text {
        height: 18px;
        line-height: 18px;
      }
      &:focus {
        border-color: $theme-color;
      }
      &:placeholder-shown::placeholder {
        color: transparent;
      }
      &:not(:placeholder-shown)::placeholder,
      &:focus::placeholder {
        color: #b0b0b0;
      }
      /* 线框样式label定位 */
      &:not(:placeholder-shown) ~ .input-label,
      &:focus ~ .input-label {
        color: $theme-color;
        transform: scale(0.75) translate(-2px, -24px);
      }
    }
    .input-text {
      width: 260px;
    }
    .input-textarea {
      width: 100%;
      box-sizing: border-box;
      resize: none;
    }
    .input-label {
      position: absolute;
      font-size: 16px;
      line-height: 1.5;
      left: 16px;
      top: 8px;
      color: #b0b0b0;
      background: #fff;
      padding: 0 2px;
      transform-origin: 0 0;
      pointer-events: none;
      transition: all 0.25s linear;
      display: none\0;
    }
  }
  .invoice-section {
    position: relative;
    padding-left: 100px;
    width: 100%;
    .tit {
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      line-height: 40px;
      text-align: right;
    }
    .invoice-tabs {
      width: 100%;
      display: flex;
      height: 40px;
      line-height: 40px;
      align-items: center;
      .invoice-type {
        flex: 1;
        border: 1px solid $border;
        text-align: center;
        cursor: pointer;
        &.active {
          border-color: $theme-color;
          color: $theme-color;
        }
        &.self {
          margin-right: 30px;
        }
      }
    }
    .invoice-input-wrap {
      input {
        width: 100%;
        height: 40px;
        padding: 10px 16px;
        border: 1px solid $border;
        font-size: 14px;
        line-height: 18px;
        background: #fff;
        box-sizing: border-box;
        transition: border-color 0.2s linear;
        &:focus {
          border-color: $theme-color;
        }
      }
      span {
        height: 40px;
        line-height: 40px;
      }
    }
  }
}
.form-foot {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  background: #f5f5f5;
  .foot-btn {
    width: 160px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    &.save {
      background: $theme-color;
      margin-right: 20px;
    }
    &.cancel {
      background: #b0b0b0;
      transition: all 0.2s;
      &:hover {
        background: #757575;
      }
    }
  }
}
.el-message{
  margin-top: 350px !important;
}
</style>